export const decemberUppercase = "pThWE";
export default {decemberUppercase};